const handleClick = (event) => {
  // Find datasets in parents
  let trackingElement = event.target;
  while (trackingElement.parentNode) {
    if (trackingElement.dataset.trackingLabel) {
      break;
    }

    trackingElement = trackingElement.parentNode;
  }

  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'event',
      'eventCategory': 'Sales Portal',
      'eventAction': 'Sign up',
      'eventLabel': trackingElement.dataset.trackingLabel,
      'eventNonInteraction': false
    });
  }

  trackingElement.removeEventListener('click', handleClick);
};

const signUpElements = document.querySelectorAll('a[data-tracking-label]');
signUpElements.forEach((element) => {
  element.addEventListener('click', handleClick);
});
